<template>
  <cus-dialog-in-dialog>
    <template v-slot:body>
      <div class="body-wrap">
        <div class="cost-list">
          <!-- 類別 radio -->
          <div class="category">
            <cus-radio :radioList="costList.category" v-model:selectValue="selectCategory"></cus-radio>
          </div>
          <div class="cost-item-wrap">
            <div class="list-wrap">
              <div class="cost-item" v-for="(item, index) in renderList" :key="index" @click="handleClick(item)">
                <p>{{ item.name }}：{{ item.amount }}</p>
                <div class="box">
                  <div v-if="item.amount" class="inner-box"></div>
                </div>
              </div>
            </div>
            <cus-page :totalPage="totalPage" v-model:currentPage="listPage"></cus-page>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="d-flex">
        <cus-button text="取消" color="white" :width="50" @click="close"></cus-button>
        <cus-button text="確定" color="blue" :width="50" @click="submit(allSelectItem)"></cus-button>
      </div>
    </template>
  </cus-dialog-in-dialog>

  <!-- 各式彈窗 -->
  <component :is="dialogTemplate"></component>
</template>
<script>
import { inject, ref, computed, watch, defineAsyncComponent } from 'vue';
import { getCostList } from '@/utils/define';
import { useDialog } from '@/utils/dialog';
export default {
  name: 'cost-list',
  components: {
    Computer: defineAsyncComponent(() => import('@/components/dialog/Computer.vue')),
  },
  setup() {
    const dialogVisible = inject('inner_dialogVisible', false);
    const close = inject('inner_close');
    const submit = inject('inner_submit');
    const { cusProps } = inject('inner_cusProps');
    //取得radio button清單
    const costList = getCostList(); //原始清單
    //設定參數
    const listPage = ref(1);
    const itemList = ref([]); //對應radio的清單
    const pageItem = ref(18);
    const totalPage = computed(() => Math.ceil(itemList.value.length / pageItem.value));
    const renderList = computed(() =>
      itemList.value.slice((listPage.value - 1) * pageItem.value, listPage.value * pageItem.value)
    );
    //設定初始值
    const allSelectItem = ref([]);
    if (dialogVisible) {
      if (cusProps.init) allSelectItem.value = JSON.parse(JSON.stringify(cusProps.init));
      costList.item.forEach((e) => {
        allSelectItem.value.forEach((select) => {
          if (select.name === e.name) e.amount = select.amount;
        });
      });
    }
    //來源切換
    const selectCategory = ref(costList.category[0].value);
    const getItemList = (category) => {
      itemList.value = [];
      costList.item.forEach((e) => {
        if (e.category === category) itemList.value.push(e);
      });
    };
    watch(
      selectCategory,
      () => {
        getItemList(selectCategory.value);
        listPage.value = 1;
      },
      { immediate: true }
    );
    //點擊
    const selectItem = ref(null);
    const { dialogTemplate, openDialog, closeDialog } = useDialog();
    const handleClick = (item) => {
      selectItem.value = item;
      openDialog('inputCost', { init: item.amount }, { dialogTitle: item.name });
    };
    const handleCostInput = (val) => {
      selectItem.value.amount = val;
      const index = allSelectItem.value.findIndex((el) => el.name === selectItem.value.name);
      const category = costList.category.filter((e) => e.value === selectItem.value.category)[0].label;
      if (val) {
        if (index === -1)
          allSelectItem.value.push({
            category,
            name: selectItem.value.name,
            amount: val,
          });
        else allSelectItem.value[index].amount = val;
      } else {
        if (index !== -1) allSelectItem.value.splice(index, 1);
      }
      closeDialog();
    };
    return {
      close,
      submit,
      costList,
      selectItem,
      listPage,
      itemList,
      selectCategory,
      totalPage,
      renderList,
      dialogTemplate,
      handleClick,
      handleCostInput,
      allSelectItem,
    };
  },
};
</script>
<style lang="scss" scoped>
.body-wrap {
  position: relative;
  padding: 0 4px;
}
.cost-list {
  height: 100%;
  display: grid;
  grid-template-rows: 12% auto;
  .category {
    width: 65%;
    margin: 0 auto;
    @include flex-center-center;
  }
  .cost-item-wrap {
    display: grid;
    grid-template-rows: auto 70px;
    border: 2px solid $color-gray-10;
    border-radius: 4px;
  }
  .list-wrap {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-template-rows: repeat(9, calc(100% / 9));
    grid-gap: 1px;
    grid-auto-flow: column;
    .cost-item {
      font-size: 2rem;
      height: 100%;
      outline: 1px solid $color-gray-10;
      padding: 0 35px;
      display: grid;
      grid-template-columns: 83% auto;
      align-items: center;
      color: $color-blue;
      position: relative;
      cursor: pointer;
      .box {
        width: 22px;
        height: 22px;
        border: 2px solid $color-blue;
        border-radius: 2px;
        margin-left: auto;
        @include flex-center-center;
        .inner-box {
          width: 14px;
          height: 14px;
          background-color: $color-blue;
          border-radius: 1px;
        }
      }
    }
  }
}
</style>
